import { defaultVariants } from './TabbedContent.styles';
import ImageWrapper from '@/helpers/Wrappers/ImageWrapper/ImageWrapper';
import RichTextWrapper from '@/helpers/Wrappers/RichTextWrapper/RichTextWrapper';
import { getCSLPAttributes } from '@/utils/type-guards';
import { IEnhancedImage, ITabbedContentModularBlock } from '@/.generated';

type TabItem = NonNullable<ITabbedContentModularBlock['tab_content_items']>[number];

interface TabbedContentPanelProps {
  item: TabItem;
  id: string;
  labelledBy: string;
  slots: ReturnType<typeof defaultVariants>;
}

export const TabbedContentPanel = ({ item, id, labelledBy, slots }: TabbedContentPanelProps) => {
  const { panel, imageContainer, imageWrapper, image, caption, rteContainer } = slots;

  const renderContent = () => {
    if (item.tab_content_type === 'Image') {
      const imgFile = item.image_data?.image;
      const imgCaption = item.image_data?.image_caption;

      if (!imgFile?.url) return null;

      const enhancedImage: IEnhancedImage = {
        image: imgFile,
        alternate_text: item.tab_title ?? imgFile.title,
        image_fit_options: 'cover',
        rounded_image: false,
        $: item.image_data?.$,
      };

      return (
        <div className={imageContainer()}>
          <ImageWrapper
            image={enhancedImage}
            sizes="(max-width: 768px) 100vw, 66vw"
            imageClassName={image()}
            wrapperClassName={imageWrapper()}
          >
            {imgCaption && (
              <RichTextWrapper
                className={caption()}
                content={imgCaption}
                {...getCSLPAttributes(item.image_data?.$?.image_caption)}
              />
            )}
          </ImageWrapper>
        </div>
      );
    }

    return (
      <RichTextWrapper
        content={item.rte}
        className={rteContainer()}
        {...getCSLPAttributes(item.$?.rte)}
      />
    );
  };

  return (
    <div id={id} role="tabpanel" aria-labelledby={labelledBy} className={panel()}>
      {renderContent()}
    </div>
  );
};
